import * as Yup from 'yup'

export const NewAuthenticationSchema = Yup.object().shape({
  username: Yup.string().required('You must enter a username.'),
  provider: Yup.string().required('You must select a provider.'),
});